import { ActionTypes as a, FixedUnit as s, DynamicUnit as t } from "./ghl-ui.es239.js";
a.setDefault, a.setCurrentToAll, a.setAuto, a.setAutoToAll, a.removeCurrent, a.removeAll;
const n = {
  margin: {
    min: -50,
    max: 50,
    suggestions: [s.Auto, "0", "10", "20", "40", "60", "80"]
  },
  padding: {
    min: 0,
    max: 50,
    suggestions: ["0", "10", "20", "40", "60", "80", "100", "140"]
  }
}, l = {
  margin: {
    min: 0,
    max: 100,
    suggestions: [s.Auto, "0", "5", "10", "25", "50", "75"]
  },
  padding: {
    min: 0,
    max: 100,
    suggestions: ["0", "5", "10", "20", "25", "50", "75", "80"]
  }
}, i = {
  margin: {
    step: 0.5,
    min: -10,
    max: 10,
    suggestions: [s.Auto, "0", "0.125", "0.25", "0.5", "1", "2"]
  },
  padding: {
    step: 0.5,
    min: 0,
    max: 10,
    suggestions: ["0", "0.125", "0.25", "0.5", "0.75", "1", "2", "3"]
  }
}, o = {
  [t.Pixels]: n,
  [t.Percent]: l,
  [t.ViewportWidth]: l,
  [t.ViewportHeight]: l,
  [t.Rem]: i,
  [t.Em]: i,
  [s.Auto]: n
}, m = Object.values(t).map((e) => ({
  label: e,
  value: e,
  meta: o[e]
})), u = Object.values(s).map((e) => ({
  label: e,
  value: e,
  meta: o[e]
})), r = m.concat(u), c = m;
export {
  m as dynamicUnits,
  u as fixedUnits,
  o as limitsMeta,
  r as marginUnits,
  c as paddingUnits
};
